/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable  @typescript-eslint/explicit-function-return-type */
import { Faq } from '../../../components/SwapKiwi/FaqSection';
import { YoutubePlayerContainer } from '../../../components/SwapKiwi/YoutubePlayerContainer';
import { PageHeader } from '../../../components/SwapKiwi/PageHeader';
import { ReactComponent as WGMILockScamFree } from '../../../assets/svg/stickers/Compositions/wgmi-lock-scamfree.svg';

export const components = [
  {
    name: PageHeader,
    props: {
      background: 'pomelo',
      title: 'How to Swap',
      description:
        '<p class="text-lg text-cloud-900">Don’t find your question here? Reach out to us on discord and twitter.</p>',
      sticker: WGMILockScamFree,
      stickerWidth: 257,
      breadcrumbs: {
        links: [
          {
            label: 'Home',
            slug: '/',
          },
          {
            label: 'How to Swap',
            slug: '/how-to-swap',
          },
        ],
      },
      notTopBorder: true,
    },
  },
  {
    name: YoutubePlayerContainer,
    props: {
      background: 'white',
      title: 'How to swap your NFTs with swap.kiwi.',
      description:
        '<p class="text-lg mb-4">The video takes 1 minute and 21 seconds of your time to help you understand how we make the swap simple, safe and reliable. Thank you for swapping with us.</p>',
      videoId: 'tLiciEieq6U',
    },
  },
  {
    name: Faq,
    props: {
      background: 'lemon',
      hasButton: false,
      title: 'FAQ',
      questions: [
        {
          title: 'How does swapping on swap.kiwi work?',
          answer:
            '<p>Alice and Bob want to swap NFTs with each other. Alice selects the NFTs in her wallet she wants to swap. She enters Bob’s wallet address and proposes the swap. Bob sees the content of Alice’s NFTs and adds his own NFTs. He initiates the swap. Alice sees now the swap content and she can either reject or accept the swap, but she can’t change anything anymore.</p>',
        },
        {
          title: 'Do both parties have to propose a swap?',
          answer:
            '<p>No. One party proposes the swap to the other. The counterpart then just goes to open swaps on swap.kiwi and continues the process.</p>',
        },
        {
          title: 'What happens with my NFTs during the swap?',
          answer:
            '<p>Your NFTs will be transferred into the escrow contract for the duration of the swap. They’ll be kept safe there until the swap is completed. Neither we nor others have access to them. You can cancel the swap and get them back as long as they are in escrow. A cancellation will transfer your NFTs back into your wallet.</p>',
        },
        {
          title: 'Why do I need to approve my NFTs?',
          answer:
            '<p>We need to be able to transfer tokens on your behalf into the kiwi escrow to execute the swap. Our smart contract can’t change your token’s behaviour or do something else with the token. You can always revoke the approval through services like etherscan or revoke.cash. We actually recommend that for all your NFTs. Disconnecting your wallet from a website is not enough. Stay safe.</p>',
        },
        {
          title: 'Do I have to select the NFTs of my counterpart?',
          answer:
            '<p>No. You choose yours. Your counterpart chooses theirs. This way you are always in charge of your NFTs.</p>',
        },
        {
          title: 'How do I know that the NFTs of my counterpart are legit?',
          answer:
            '<p>We are fetching the information if an NFT is legit from opensea. Each contract is vetted individually and the verification batch is added based on the information we receive. We encourage you to double check the NFTs yourself on i.e. opensea.io.</p>',
        },
        {
          title: 'Which tokens are supported?',
          answer:
            '<p>We are supporting ERC-721, ERC-1155 and Ether to top up the swap. We are exploring options to add more tokens on a later stage. Feel free to reach out to share tokens you would like to add to a swap. </p>',
        },
        {
          title: 'What wallets are supported?',
          answer: '<p>We are supporting MetaMask and basically all mobile wallets via WalletConnect for now.</p>',
        },
        {
          title: 'Does swap.kiwi charge any fees? ',
          answer: '<p>No. You have to pay a gas fee for the swap but that’s for the miners, not for us.</p>',
        },
      ],
    },
  },
];
